export const LOAD_PRODUCTS = 'load_products'

export function loadProducts (products) {
  return {
    type: LOAD_PRODUCTS,
    payLoad: products
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/productActions.js